/**
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2024 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * @file HeaderStyles.jsx - A component for agentic header styles.
 */

import { colors } from '../../constants/StyleConstants';

const HeaderStyles = () => ({
  headerContainer: {
    top: 0,
    width: '80%',
    position: 'fixed',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    height: 64,
    margin: 'auto',
    transform: 'translate(10%, 0%)'
  },
  headerWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  heading: {
    flex: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  graphHeading: {
    fontSize: 20,
    color: colors.WHITE,
    flex: '0 1 auto',
    zIndex: 1000
  },
  graphNameEllipsis: {
    display: 'inline-block',
    maxWidth: 250,
    verticalAlign: 'bottom',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  formContainer: {
    minWidth: '220px !important',
    zIndex: 1000,
    color: colors.WHITE,
    '& fieldset': {
      borderColor: `${colors.WHITE} !important`
    }
  },
  color: {
    color: `${colors.WHITE} !important`
  },
  inputOutline: {
    borderColor: `${colors.WHITE} !important`
  }
});

export default HeaderStyles;
